export const SAVE_FUEL_SAVINGS = 'SAVE_FUEL_SAVINGS';
export const CALCULATE_FUEL_SAVINGS = 'CALCULATE_FUEL_SAVINGS';

export const EXPAND_MENU = 'EXPAND_MENU';
export const COLLAPSE_MENU = 'COLLAPSE_MENU';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js